const UserInfo_KEY = "user_info";
import Setting from '@/setting';

const storage = {};

/**
 * @description 储存 用户登录信息
 * @param {String} name cookie name
 * @param {String} value cookie value
 * @param {Object} cookieSetting cookie setting
 */
storage.setUserInfo = (value) => {
    let StrJson = JSON.stringify(value);
    Setting.StorageType.setItem(UserInfo_KEY, StrJson);
};

/**
 * @description 获取 用户登录信息
 */
storage.getUserInfo = () => {
    const UserNew = Setting.StorageType.getItem(UserInfo_KEY);
    if (UserNew) {
        return JSON.parse(UserNew);
    } else {
        return {};
    }
};

/**
 * @description 删除 sessionStorage
 */
storage.remove = () => {
    Setting.StorageType.clear();
}

export default storage;